import axios from 'axios'
import URLS from '../../util/urls'

const state = {
  form: {
    id: 0,
    nome: undefined,
    estado: {},
    variacoesNome: []
  },

  formPesquisa: {
    nome: '',
    estado: {}
  },

  cidades: [],

  quantidadeCidades: 0
}

const mutations = {
  atualizarCidades(state, payload) {
    state.cidades = payload
  },

  atualizarCidadeSelecionada(state, payload) {
    state.form.id = payload.id
    state.form.nome = payload.nome
    state.form.estado = payload.estado
    state.form.variacoesNome = payload.variacoesNome
  },

  limparForm(state) {
    state.form = {
      id: 0,
      nome: '',
      estado: {}
    }
  },

  limparFormPesquisa() {
    state.formPesquisa = {
      nome: '',
      estado: {}
    }
  },

  setQuantidadeCidades(state, payload) {
    state.quantidadeCidades = payload
  }
}

const actions = {
  limparForm(context) {
    context.commit('limparForm')
  },

  limparFormPesquisa(context) {
    context.commit('limparFormPesquisa');
  },

  listarCidades(context, payload) {
    return axios.post(URLS.CIDADES_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarCidades', response.data.lista);
          context.commit('setQuantidadeCidades', response.data.quantidade);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, {root: true})
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('listarCidades', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  recuperarCidade(context, payload) {
    return axios.post(URLS.CIDADES_RECUPERAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarCidadeSelecionada', response.data);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('recuperarCidade', payload);
            } 
          }).catch(error => {
            throw error;
          });
        default:
          context.commit('atualizarCidadeSelecionada', response.data);
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  gravarCidade(context, payload) {
    return axios.post(URLS.CIDADES_GRAVAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarCidadeSelecionada', response.data.item);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('gravarCidade', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
            context.commit('atualizarCidadeSelecionada', response.data.item);
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  removerCidade(context, payload) {
    return axios.post(URLS.CIDADES_REMOVER, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('removerCidade');
            }
          }).catch(error => {
            throw error;
          });
        default:
          if(response.data.status !== 'FALHA') {  
            context.commit('limparForm')
          }
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  gravarVariacoesNome(context, payload) {
    return axios.post(URLS.CIDADES_GRAVAR_VARIACAO, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, {root: true})
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('gravarVariacoesNome', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          context.commit('atualizarCidadeSelecionada', response.data.item);
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },
}

export default {
    state,
    mutations,
    actions
}